import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgArrowLeftDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgArrowLeft = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#a)">
      <mask
        id="b"
        x="0"
        y="0"
        width="16"
        height="16"
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="currentColor"
          d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10"
        />
      </mask>
      <g mask="url(#b)">
        <path
          fill="currentColor"
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        />
      </g>
      <path
        d="M8.4 5.2L5.6 8L8.4 10.8M5.8 8H10.8"
        stroke="#ffffff"
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
